import { render, staticRenderFns } from "./viewGroupBusiness.vue?vue&type=template&id=478c7e28&"
import script from "./viewGroupBusiness.vue?vue&type=script&lang=js&"
export * from "./viewGroupBusiness.vue?vue&type=script&lang=js&"
import style0 from "./viewGroupBusiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports